<script setup>
import { BLink, BModal } from 'bootstrap-vue-next';
import { computed } from 'vue';

import MarkdownRenderer from '~/common/components/MarkdownRenderer.vue';
import UserWithGitLabProfileLink from '~/common/components/UserWithGitLabProfileLink.vue';

import ContributorSocialLinks from './ContributorSocialLinks.vue';

const props = defineProps({
  release: {
    type: Object,
    default: null,
  },
});

const model = defineModel({ type: Boolean });

const modalTitle = computed(() => {
  if (!props.release) {
    return '';
  }

  const names = props.release.contributors
    .map(c => c.name)
    .join(', ');

  return `${props.release.release} (${props.release.date}) — ${names}`;
});

const contributorsWithUsernames = computed(() => {
  return props.release?.contributors.filter(c => c.gitlabUsername) || [];
});
</script>

<template>
  <BModal
    v-model="model"
    :title="modalTitle"
    size="lg"
    scrollable
    no-footer
  >
    <div v-if="release">
      <img
        v-for="contributor in contributorsWithUsernames"
        :key="contributor.gitlabUsername"
        loading="lazy"
        :src="`/users/${contributor.gitlabUsername}/banner.svg`"
        :alt="`${contributor.name} contributor banner`"
        class="w-100 mb-2"
      >

      <p class="mt-2">
        The
        <BLink
          v-if="release.releasePostUrl"
          :href="release.releasePostUrl"
          target="_blank"
        >
          {{ release.release }} release
        </BLink>
        <span v-else>{{ release.release }} release</span>
        {{ release.contributors.length > 1 ? 'notable contributors are' : 'notable contributor is' }}
        <span
          v-for="(contributor, index) in release.contributors"
          :key="contributor.gitlabUsername || contributor.name"
        >
          <span v-if="index > 0"> and </span>
          <UserWithGitLabProfileLink
            v-if="contributor.gitlabUsername"
            :username="contributor.gitlabUsername"
            :name="contributor.name"
          />
          <span v-else>{{ contributor.name }}</span>
        </span>
      </p>

      <MarkdownRenderer
        v-if="release.writeUp"
        :markdown-content="release.writeUp"
        use-marked-renderer
      />

      <ContributorSocialLinks :contributors="release.contributors" />
    </div>
  </BModal>
</template>
